import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import RequestStatus from "../RequestStatus";
import { DocumentIntakeBookmark } from "generated/graphql";

export const selectPageStatus = (state: RootState): RequestStatus => state.intakeviewer.status;
export const selectDocumentSegmentPageCache = createSelector(
  [
    (state: RootState) => state.intakeviewer,
    (_state, [documentSegmentId, pageNumber]) => [documentSegmentId, pageNumber],
  ],
  (intakeViewer, [documentSegmentId, pageNumber]) => {
    const documentSegmentCache = intakeViewer.documentSegments[documentSegmentId];
    const pageCache = documentSegmentCache ? documentSegmentCache[pageNumber] : undefined;
    return pageCache || undefined;
  }
);
export const selectBookmarks = (state: RootState): DocumentIntakeBookmark[] => state.intakeviewer.bookmarks;
